<ng-template [ngIf]="book !== null" [ngIfElse]="loading">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 margin-block">
      <mat-card class="row box-shadow ">

        <!-- <div class="col-12 ">
          <div class="row justify-content-end" style="margin: 15px;">
            <ng-template [ngIf]="canCancel">
              <button (click)='openConfirm();' mat-flat-button color="warn">
                Annuler la réservations
              </button>
            </ng-template>
          </div>
        </div> -->
        <div class="col-12">
          <app-book-info-block [book]="book"></app-book-info-block>
        </div>
      </mat-card>
    </div>

    <!-- <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <app-book-edit-block *ngIf='book.status == "reserved"' [book]="book"></app-book-edit-block>
        </div>
         <div class="col-12 col-md-8">
          <app-book-eco-bilan *ngIf='book.status == "completed"' [book]="book"></app-book-eco-bilan>
        </div> 
      </div>
    </div> -->
  </div>
</ng-template>
<ng-template #loading>
  <div class="row justify-content-center">
    <div class="col-4">
      <!-- <mat-icon style="width: 100%; height: 100%; " svgIcon="autopartage"></mat-icon> -->
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</ng-template>
